module.exports = __webpack_public_path__ + "img/ruststationlogo.21ffc166.svg";